
export default function StickyBottomBar() {
  const openWhatsApp = () => {
    window.open('https://wa.me/905078064479', '_blank');
  };

  const openInstagram = () => {
    window.open('https://www.instagram.com/clearalignerbox?igsh=OWFrY2x0ODE5enJt&utm_source=qr', '_blank');
  };

  const openEmail = () => {
    window.open('mailto:clearalignerbox@gmail.com', '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="sticky-bottom">
      <div className="container-max">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button 
              onClick={openWhatsApp}
              className="w-12 h-12 bg-[#25D366] text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              title="WhatsApp"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
            </button>
            
            <button 
              onClick={openInstagram}
              className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              title="Instagram"
            >
              <i className="ri-instagram-fill text-xl"></i>
            </button>
            
            <button 
              onClick={openEmail}
              className="w-12 h-12 bg-[#D4AF37] text-black rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              title="E-posta"
            >
              <i className="ri-mail-fill text-xl"></i>
            </button>
          </div>
          
          <button 
            onClick={scrollToContact}
            className="btn-primary text-sm px-6 py-3"
          >
            <i className="ri-message-3-line mr-2"></i>
            Hızlı İletişim
          </button>
        </div>
      </div>
    </div>
  );
}